export class AnimacaoHelper {

 /**
  * Realiza o Scroll Up da tela, movendo a mesma para o topo tendo como base o delay
  * @param dalayInMiliseconds Tempo em milisegundos no qual o scroll up permanecerá sendo executado.
  */
  public static ScrollUpTela(delayEmMilisegundos : number) {

    // O mesmo que setTimeout (), mas repete a execução da função continuamente.
    let moverParaCima = window.setInterval(() => {

        // Número de pixels em que o documento está rolado no eixo vertical.
        let posicao = window.pageYOffset;

        // Posição maior que 0 indica que a tela não está no topo.
        if (posicao > 0) {

           // Move a tela para o topo da página, diminuindo a posição gradativamente.
           window.scrollTo(0, posicao - 50); 

        } else {

            // Realiza a limpeza do Timer.
            window.clearInterval(moverParaCima);
        }
      }, delayEmMilisegundos);
      
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/animacao-helper.ts